var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.modalFilterDateFrom = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "purchaseData.dateFrom"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateFrom = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .dateFromFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "dateFromFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.dateFromFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterDateFrom = $$v
                                    },
                                    expression: "modalFilterDateFrom"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateFrom = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateFrom,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateFrom", $$v)
                                        },
                                        expression: "filter.dateFrom"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateFrom = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.modalFilterDateTo = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "purchaseData.dateTo"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateTo = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.dateToFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "dateToFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.dateToFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateTo,
                                    callback: function($$v) {
                                      _vm.modalFilterDateTo = $$v
                                    },
                                    expression: "modalFilterDateTo"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateTo = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateTo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateTo", $$v)
                                        },
                                        expression: "filter.dateTo"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateTo = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.billedItemsValues,
                                  label: _vm.$t("purchaseData.datatable.billed")
                                },
                                model: {
                                  value: _vm.filter.billed,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "billed", $$v)
                                  },
                                  expression: "filter.billed"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: {
                      url: "/purchaseData",
                      filter: this.filter,
                      filterExport: _vm.filterExport
                    }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "item-key": "code",
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function(ref) {
                    var items = ref.items
                    return [
                      items.length > 0
                        ? _c(
                            "tbody",
                            _vm._l(items, function(item) {
                              return _c("tr", { key: item.code }, [
                                _c("td", [_vm._v(_vm._s(item.order))]),
                                _c("td", [
                                  _vm._v(_vm._s(item.expedition.token))
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.expedition.deliveryOrderId)
                                  )
                                ]),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      { name: "nl2br", rawName: "v-nl2br" }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.expedition.additionalServices
                                            .filter(function(x) {
                                              return x.purchased
                                            })
                                            .map(function(x) {
                                              return (
                                                x.productTypeCode + "-" + x.name
                                              )
                                            })
                                            .join(",\n\r")
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.transformDate(
                                          item.creationDate,
                                          _vm.$t("global.dateHourFormat")
                                        )
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(item.expedition.senderCode))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(item.expedition.senderName))
                                ]),
                                _c("td", [_vm._v(_vm._s(item.buyersName))]),
                                _c("td", [_vm._v(_vm._s(item.buyersAddress))]),
                                _c("td", [
                                  _vm._v(_vm._s(item.buyersPostalCode))
                                ]),
                                _c("td", [_vm._v(_vm._s(item.buyersCity))]),
                                _c("td", [
                                  _vm._v(_vm._s(item.buyersTelephone))
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c("i18n-n", {
                                      staticClass: "item__value",
                                      attrs: { tag: "span", value: item.amount }
                                    })
                                  ],
                                  1
                                ),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.resultCode === "0000"
                                          ? _vm.$t("global.yes")
                                          : _vm.$t("global.no")
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("td", [_vm._v(_vm._s(item.resultCode))]),
                                _c(
                                  "td",
                                  [
                                    _c("v-switch", {
                                      on: {
                                        change: function($event) {
                                          return _vm.updateBilled(item)
                                        }
                                      },
                                      model: {
                                        value: item.billed,
                                        callback: function($$v) {
                                          _vm.$set(item, "billed", $$v)
                                        },
                                        expression: "item.billed"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            }),
                            0
                          )
                        : _c("tbody", [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { colspan: _vm.headers.length }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "global.datatable.noMatchingResults"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }